import { render, staticRenderFns } from "./lessonIcon.vue?vue&type=template&id=728d5f7a&scoped=true&"
import script from "./lessonIcon.vue?vue&type=script&lang=ts&"
export * from "./lessonIcon.vue?vue&type=script&lang=ts&"
import style0 from "./lessonIcon.vue?vue&type=style&index=0&id=728d5f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d5f7a",
  null
  
)

export default component.exports